import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-edb419e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-box" }
const _hoisted_2 = { class: "img-box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "data-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Typ urządzenia", -1))
const _hoisted_7 = { class: "data-box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Nazwa", -1))
const _hoisted_9 = { class: "data-box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Połączenie", -1))
const _hoisted_11 = { class: "button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require(`@/assets/${$props.device.iconGreen}.svg`),
        alt: "temp",
        class: "svg-green"
      }, null, 8, _hoisted_3),
      _createElementVNode("img", {
        src: require(`@/assets/${$props.device.iconWhite}.svg`),
        alt: "temp",
        class: "svg-white"
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("p", null, _toDisplayString($props.device.type), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("p", null, _toDisplayString($props.device.name), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("p", null, _toDisplayString($props.device.connectionState), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.openDialog($props.device.id)))
      }, "Więcej")
    ])
  ]))
}